import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tab,
  Typography,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Add, AddAPhoto, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import dayjs from "dayjs";
import NormalTable from "../../../Component/NormalTable";
import { eventSample } from "../../../SampleData/EventSample";
import { shiftPersonal } from "../../../SampleData/ShiftPersonal";
import { useSelector } from "react-redux";
import shiftImage from "../../../images/Shift_Handover_Report.png"

const ShiftHistoryModal = ({ mode, handleCloseClick, editData }) => {
  const [parentId, setParentId] = useState([]);
  const [value, setValue] = useState("1");
  console.log("editdata", editData);
  const [loading, setLoading] = useState(false);
  const [docData, setDocData] = useState(eventSample);
  const [personalData, setPersonalData] = useState(shiftPersonal);
  const siteName = useSelector((state) => state.auth.loginInfo.siteName);
  const handleTab = (e, newValue) => {
    setValue(newValue);
  };
  //   useEffect(() => {
  //    getData()
  //   }, []);

  //   const getData=async()=>{
  //     setLoading(true)
  //     const link = masterAPI["assetCategory"].link;
  //    await axiosPrivate
  //       .get(`${link}`)
  //       .then((res) => {
  //         setLoading(false)
  //         setParentId(res.data.result);
  //       })
  //       .catch((e) => {
  //         setLoading(false)
  //         setParentId([])
  //         console.log(e, "createACgetAll");
  //       });
  //   }

  //   const initialValue = {
  //     code: mode==="Edit"?editData.code: "",
  //     assetCategoryName: mode==="Edit"?editData.assetCategoryName: "",
  //     // parentCategoryId:mode==="Edit"?editData.parentCategoryId: null,
  //   };

  //   const onSubmit = async(value) => {
  //     console.log(value);
  //     setLoading(true)
  //     const createLink = masterAPI["assetCategory"].create;
  //     const updateLink=masterAPI["assetCategory"].update
  //     if(mode==="Create"){
  //      await axiosPrivate.post(`${createLink}`,value).then(res=>{
  //         console.log(res.data)
  //         setLoading(false)
  //         handleCloseClick()
  //       }).catch(e=>{
  //         setLoading(false)
  //         console.log(e,"createAC")
  //       })
  //     }else{
  //       const updateAC={
  //         id:editData.id,
  //         ...value
  //       }
  //      await axiosPrivate.put(`${updateLink}`,updateAC).then(res=>{
  //         console.log(res.data)
  //         setLoading(false)
  //         handleCloseClick()
  //       }).catch(e=>{
  //         setLoading(false)
  //         console.log(e,"updateAC")
  //       })
  //     }

  //   };

  const handleCancel = () => {
    handleCloseClick();
  };
  const columns = [
    {
      Header: "Priority",
      accessor: "Priority",
    },
    {
      Header: "Event Code",
      accessor: "Notification_key",
    },
    {
      Header: "Status",
      accessor: "Status",
    },
    {
      Header: "Shift resp area key",
      accessor: "Shift_resp_area_key",
    },
    {
      Header: "Done",
      accessor: "Done",
    },
    // {
    //   Header: "Notification type key",
    //   accessor: "Notification_type_key",
    // },
    {
      Header: "Location",
      accessor: "Position_key",
    },
    {
      Header: "Asset Code",
      accessor: "Maint_object_key",
    },
    {
      Header: "Reported by",
      accessor: "Reported_by",
    },
    {
      Header: "Order date time",
      accessor: "Order_date_time",
    },
    {
      Header: "Responsible",
      accessor: "Responsible",
    },
    {
      Header: "Work Order Code",
      accessor: "Work_order_key",
    },
    {
      Header: "Work order status",
      accessor: "Work_order_status",
    },
    {
      Header: "Event Name",
      accessor: "Notification_name",
    },
    {
      Header: "Shift ID",
      accessor: "Shift_ID",
    },
    {
      Header: "Extra Event Info",
      accessor: "Extra_notification_info",
    },
    {
      Header: "Document",
      accessor: "Document",
    },
    {
      Header: "Shift Code",
      accessor: "Site",
    },
    // {
    //   Header: "Legal unit key",
    //   accessor: "Legal_unit_key",
    // },
    // {
    //   Header: "Currency",
    //   accessor: "Currency",
    // },
    // {
    //   Header: "Plant_key",
    //   accessor: "Plant_key",
    // },
    // {
    //   Header: "Sour",
    //   accessor: "sour",
    // },
  ];
  const columnsPersonal = [
    {
      Header: "Labour Code",
      accessor: "Work_Supp_Key",
    },
    {
      Header: "Start Date",
      accessor: "Start_Date",
    },
    {
      Header: "Start Time",
      accessor: "Start_Time",
    },
    {
      Header: "End Date",
      accessor: "End_Date",
    },
    {
      Header: "End Time",
      accessor: "End_Time",
    },
  ];
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
       Shift History Details
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                    }}
                  >
                    {/* {mode === "Edit"
                                      ? editData.code + "-" + editData.serviceRequestName
                                      : "New Service Request"} */}
                  </Typography>
                </Box>
                {/* <Divider
                      sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                    /> */}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  value={editData.id}
                  InputProps={{
                    readOnly: true,
                  }}
                  type="text"
                  name="code"
                  placeholder="Enter Shift Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site
                </Typography>
                <TextField
                  size={"small"}
                  value={siteName}
                  type="text"
                  placeholder="Enter Site"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift Type Code
                </Typography>
                <Field
                  as={TextField}
                  size="small"
                  value={editData.Shift_type_key}
                  type="text"
                  name="code"
                  placeholder="Enter Shift Type Code"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Responsible
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  value={editData.Responsible}
                  InputProps={{
                    readOnly: true,
                  }}
                  type="text"
                  name="code"
                  placeholder="Enter Insstruction Key"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift Start
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY hh:mm"
                      value={dayjs("2020-01-31T09:35")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                      //   onChange={(newValue) => {
                      //     console.log(newValue);
                      //     if (newValue !== null) {
                      //       if (`${newValue.$d}` !== "Invalid Date") {
                      //         const dateFrom = moment(newValue.$d).format(
                      //           "YYYY-MM-DD"
                      //         );
                      //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                      //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                      //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                      //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                      //         setFieldValue("installationDate", dateFormat);
                      //       }
                      //     }
                      //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift End
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY hh:mm"
                      value={dayjs("2020-01-31T09:35")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                      //   onChange={(newValue) => {
                      //     console.log(newValue);
                      //     if (newValue !== null) {
                      //       if (`${newValue.$d}` !== "Invalid Date") {
                      //         const dateFrom = moment(newValue.$d).format(
                      //           "YYYY-MM-DD"
                      //         );
                      //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                      //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                      //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                      //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                      //         setFieldValue("installationDate", dateFormat);
                      //       }
                      //     }
                      //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift resp area key
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  value={"Long term work pending"}
                  type="text"
                  name="code"
                  InputProps={{
                    readOnly: true,
                  }}
                  placeholder="Enter Insstruction Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mt: 2 }} />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            ></Box>
            <TabContext value={value}>
              <TabList onChange={handleTab} aria-label="lab API tabs example">
                <Tab label="Event" value="1" />
                <Tab label="Personal" value="2" />
              </TabList>

              <TabPanel value="1" sx={{ p: 0, pt: 1 }}>
                <IconButton>
                  <Add></Add>
                </IconButton>
                <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
                <NormalTable columns={columns} data={docData} />

                <Grid item xs={12}>
                  <Grid container spacing={"1rem"}>
                    <Grid
                      container
                      item
                      xs={12}
                      justifyContent={"flex-start"}
                      gap="1rem"
                    >
                      <Button
                        variant="contained"
                        disabled={loading}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        New Notif
                      </Button>
                      <Button
                        variant="contained"
                        disabled={true}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        Edit Notif
                      </Button>
                      <Button
                        variant="contained"
                        disabled={true}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        Del Notif
                      </Button>
                      <Button
                        variant="contained"
                        disabled={true}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        Done
                      </Button>
                      <Button
                        variant="contained"
                        disabled={true}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        Not Done
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = shiftImage
                          link.download = "ShiftHandoverReport.png"; 
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        sx={{
                          textTransform: "none",
                          backgroundColor: loading
                            ? "default"
                            : color.TableButtonColor,
                          "&:hover": {
                            backgroundColor: loading
                              ? "default"
                              : color.buttonDisable,
                          },
                        }}
                      >
                        Print
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2" sx={{ p: 0, pt: 1 }}>
                <Grid item xs={12}>
                  <IconButton>
                    <Add></Add>
                  </IconButton>
                  <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />

                  <NormalTable
                    columns={columnsPersonal}
                    data={personalData}
                    filt={true}
                  />
                </Grid>
              </TabPanel>
            </TabContext>

            <Grid container spacing={"1rem"}>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ShiftHistoryModal;
